import { put } from 'redux-saga/effects';
import get from 'lodash/get';
import { PDP_ATC_CLICK_EVENT } from '../actionTypes/AnalyticsActionTypes';

const getContext =
    (!__SERVER__ && window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.context) || {};
const featureFlags = getContext.featureFlags || {};

export default function* ClickStreamLogger(data) {
    if (get(featureFlags, 'enableClickStreamLogs', true)) {
        const { name, value } = get(data, 'attributes');

        const clickStreamData = {
            logData: value,
            logType: name,
            pageType: get(window.digitalData, 'page.pageInfo.pageType', window.location.pathname),
        };
        const customLogObj = {
            type: PDP_ATC_CLICK_EVENT,
            clickStreamData,
        };
        yield put(customLogObj);
    }
}
